/**
 * Util module
 * This module contains commonly used functions.
 *
 * Last Edit:
 * 4/30/15 by ML @ 12:57PM
 *
 */
define(['StandardModule'], function(parentModel) {

    function thisObject(o) {

		var defaults = {
            type: 'module', 
            author: 'Hussein Sharif',
        };
		
        defaults = $.extend(true, defaults, o);
        parentModel.call(this, defaults);
        return (this);
    };

    // Inherit parent methods/variables
    thisObject.prototype = Object.create(parentModel.prototype);

    // Listeners
    thisObject._startlisteners = function() {
	
      this.notify('Trace','_startlisteners');
      var parent=this;
      var myID=  this._id();
	  
      _notify.add(this._id(), function() {
      return {}
      }());
    };
	
	/* Initialize function */
	thisObject.init = function() {
		this.notify('Trace', 'init');
		this._startlisteners(); 
		return self;
	};

	/* Refresh function */
	thisObject.refresh = function(initFlag) {
	   var self = this;
	   self.notify('Trace', 'refresh');
	};
	
	/* Kill function */
	thisObject.kill = function() {
		this.notify('Trace', 'kill');
		_notify.rem(this._id());
	};
	
	
	/* Convert a float data type to a ratio. 
	*
	* x: The float number that will be converted to a fraction
	*/
	thisObject.floatToRatio= function(x) {
		var tolerance = 1.0E-6;
		var h1=1; var h2=0;
		var k1=0; var k2=1;
		var b = x;
		do {
			var a = Math.floor(b);
			var aux = h1; h1 = a*h1+h2; h2 = aux;
			aux = k1; k1 = a*k1+k2; k2 = aux;
			b = 1/(b-a);
		} while (Math.abs(x-h1/k1) > x*tolerance);
		
		return h1+"/"+k1;
	}
	
	
	/* Load a CSS  file
	*
	*nameOfDoc : Name of a file you want the url for, minus the suffix (.js, .css, etc)
	*contentToCut: The beginning of the part of the url you'd like to truncate
	*appendContent: The string you'd like to append to the end of your URL
	*/
	thisObject.loadCss = function(nameOfDoc, contentToCut, appendContent) {
		
		var url = this._urlFinder(nameOfDoc, contentToCut, appendContent);
		
		var link = document.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = url;
		$("head").append(link);
	}
	
	
	/* Find the url of the current file, typically called by
	*
	*nameOfDoc : String, name of the file you want the url for, minus the suffix (.js, .css, etc)
	*contentToCut: String, the beginning of the part of the url you'd like to truncate
	*appendContent: String, the string you'd like to append to the end of your URL
	*/
	thisObject._urlFinder = function(nameOfDoc, contentToCut, appendContent) {
	
		var currentUrl;
		
		var scriptElements = document.getElementsByTagName('script');
		var i, element, myfile;
		 
		for( i = 0; element = scriptElements[i]; i++ ) {
 
			myfile = element.src;
 
			if( myfile.indexOf( nameOfDoc ) >= 0 ) {
				currentUrl = myfile.substring( 0, myfile.indexOf( nameOfDoc ) );
			}
		}

		// Cut off end of URL and add relative path to css file needed
		var url = currentUrl.substr(0, currentUrl.indexOf(contentToCut)) + appendContent;
		
		return url;
	}
	
	
	/* Returns true if the current device is mobile, else returns false */
	thisObject.isMobile = function (){
		return(/android|webos|iphone|ipod|blackberry|iemobile|opera mini|windows ce|windows phone/i.test(navigator.userAgent.toLowerCase()));
	}
	
	
	/* Returns the current environment the code is running on */
	thisObject.environment = function () {
		// All the code below determines the environment and builds the proper string
		var environments = ["proddev","staging","qa01", "qa02"];
		var currentEnv = "";
		
		// Determine environment
		$.each(environments, function(index,value) {
			if ($.inArray(value, window.location.host.split(".")) === 1){
				currentEnv = value;
			}
		});
		
		return currentEnv;
	}
		
	/* Alternate Environment Checking Function, Handles all combination of qa/staging/proddev and inserts a period, for direct use in URLs */
	thisObject.envCheck = function () {
		var env = '';				
		if (window.location.href.indexOf(".staging.") != -1) {
			env = ".staging";
		}			
		else if (window.location.href.indexOf(".proddev.") != -1) {
			env = ".proddev";
		}
		if (window.location.href.match(/\.qa\d\d/) != null) {
			env = env + window.location.href.match(/\.qa\d\d/)[0];
		}
		return env;
	}
		
	// Turn Date Object to Full Month / Day string
	thisObject.readableDate = function (utc) {	
		var utcDate = new Date(Number(utc)).toDateString();		
		var utcDateDay = utcDate.split(' ')[0];
		switch (utcDateDay)
			{
				case "Sun":	utcDateDay = "Sunday";	break;
				case "Mon":	utcDateDay = "Monday";	break;
				case "Tue":	utcDateDay = "Tuesday"; break;
				case "Wed":	utcDateDay = "Wednesday"; break;			
				case "Thu":	utcDateDay = "Thursday"; break;
				case "Fri":	utcDateDay = "Friday";	break;
				case "Sat":	utcDateDay = "Saturday"; break;
			}			
		var utcDateMonth = utcDate.split(' ')[1];
		switch (utcDateMonth)
			{
				case "Jan":	utcDateMonth = "January";	break;
				case "Feb":	utcDateMonth = "February";	break;
				case "Mar":	utcDateMonth = "March"; break;
				case "Apr":	utcDateMonth = "April"; break;			
				case "May":	utcDateMonth = "May"; break;
				case "Jun": utcDateMonth = "June"; break;
				case "Jul": utcDateMonth = "July"; break;
				case "Aug": utcDateMonth = "August"; break;
				case "Sep": utcDateMonth = "September"; break;
				case "Oct": utcDateMonth = "October"; break;
				case "Nov": utcDateMonth = "November"; break;
				case "Dec": utcDateMonth = "December"; break;
			}			
		var utcDateStr = utcDate.split(' ')[2];
		if (utcDateStr.length == 2 && utcDateStr[0] == "1") {
			utcDateStr = utcDateStr + "th";
		}
		else if (utcDateStr[utcDateStr.length-1].match(/0|4-9/) != null) {
			utcDateStr = utcDateStr + "th";
		}
		else if (utcDateStr[utcDateStr.length-1] == "1") {
			utcDateStr = utcDateStr + "st";
		}
		else if (utcDateStr[utcDateStr.length-1] == "2") {
			utcDateStr = utcDateStr + "nd";
		}
		else if (utcDateStr[utcDateStr.length-1] == "3") {
			utcDateStr = utcDateStr + "rd";
		}
		
		return String(utcDateDay + ', ' + utcDateMonth + ' ' + utcDateStr + ', ' + utcDate.split(' ')[3]);
	}

	/* Returns true if the current device is Retina display */
	thisObject.isRetina = function () {
		return (window.devicePixelRatio > 1);
	}
	
	/* Returns true if the current device is iPhone */
	thisObject.isIphone = function () {
		return navigator.userAgent.match(/iPhone/i) != null;
	}
	
	/* Returns true if the current device is ipad */
	thisObject.isIpad = function () {
		return navigator.userAgent.match(/iPad/i) != null;
	}
	
	/* Returns iOS version */
	thisObject.iOsVer = function () {
		if (this.isIpad() || this.isIphone()) {
			return Number(navigator.userAgent.match(/OS \d+/)[0].split(' ')[1]);
		}
		else {
			return 0;		
		}
	}
	
	/* Returns true if the current device is IE */
	thisObject.isIE = function () {
		return (navigator.userAgent.toLowerCase().match(/msie \d+/) != null || navigator.userAgent.toLowerCase().match(/trident.*rv:\d+/) != null);
	}
	
	/* Returns IE version */
	thisObject.ieVer = function () {
		if (navigator.userAgent.toLowerCase().match(/msie \d+/) != null) {
			return Number(navigator.userAgent.toLowerCase().match(/msie \d+/)[0].split(' ')[1]);
		}
		else if (navigator.userAgent.toLowerCase().match(/trident.*rv:\d+/) != null) {	
			return Number(navigator.userAgent.toLowerCase().match(/trident.*rv:\d+/)[0].split('rv:')[1]);
		}
		else {
			return 0;
		}
	}
	
	thisObject.isAndroid = function () {
		return navigator.userAgent.match(/android/i) != null;
	}
	
	/* Returns iOS version */
	thisObject.droidVer = function () {
		if (this.isAndroid()) {
			return Number(navigator.userAgent.match(/Android \d\.\d/)[0].substring(8, 11));
		}
		else {
			return 0;		
		}
	}
	
    //-----------------------------------------------------------------------------------------------------------------------------------------------//

	return (thisObject);

});



// WEBPACK FOOTER //
// ./modules/controllers/util.js